import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { sendToVercelAnalytics } from './vitals';
import { Provider } from 'react-redux';
import { store } from "./app/store";
import { BookingProvider } from './context/BookingProvider';
ReactDOM.render(
  <React.StrictMode>
       <Provider store={store}>
      <BookingProvider>
        <App />
      </BookingProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals(sendToVercelAnalytics);
